import { makeTheme } from 'dripsy';

import { Buttons, Fonts, Layouts, Shadows, Spacings, Texts } from './styles';

export const baseTheme = makeTheme({
  ...Texts.htmlTexts,
  borders: Buttons.borders,
  buttons: Buttons.buttons,
  fontSizes: Fonts.fontSizes,
  fontWeights: Fonts.fontWeights,
  layout: Layouts.layout,
  lineHeights: Spacings.lineHeights,
  sizes: Spacings.sizes,
  space: Spacings.space,
  text: Texts.text,
  shadows: Shadows.shadows,
  borderRadius: Spacings.space
});
